<template>
  <div class="productDetailToast"
    :data-visible="showProductDetail"
    :data-loading="isLoading">
    <div class="productDetailToast__content">
      <app-loading
        class="productDetailToast__loading"
        :is-loading="isLoading"
      ></app-loading>
      <div class="container">
        <div class="productDetailToast__header">
          <div class="productDetailToast__title media"
            data-align="center">
            <div class="media__image" style="width: 72px">
              <uranai-img data-clip-path-support="true" data-size="sm" size="sm"
                :src="packImage || item.pack_image" :alt="item.item_name"
                width="44" height="48"
              ></uranai-img>
            </div>
            <div class="media__content">
              <div class="badge service_type">
                <span>{{ item.service_type_str }}</span>
              </div>
              <!-- <span class="u-tx-brand-2">{{ item.service_type_str }}</span> -->
              <div class="title">{{ item.item_name }}</div>
              <div class="counselorName" v-if="item.item_theme">{{ item.item_theme }}</div>
              <div class="counselorName" v-else>{{ item.counselor_name }}</div>
            </div>
          </div>
        </div>
        <div class="price">
          <div>価格</div>
          <strong class="u-tx-brand"><span v-price="item.price_taxin"></span>（税込）</strong>
        </div>
        <div class="productDetailToast__footer">
          <!--
            応募対象によって入力画面に遷移する実装が違うため、
            要素を呼び出す際にtype属性を付与する
            type=text|lottery
          -->
          <a :href="inputLink" class="btn"
            v-if="type === 'text'"
            data-block="true"
            data-size="sm"
            data-color="primary"
            @click="sendEventText"
          >プロフィールを入力する</a>
          <form v-else-if="type === 'lottery'"
            action="/movie/lottery/profile"
            method="post">
            <input type="hidden" name="_token" :value="token">
            <input type="hidden" name="cpno" :value="cpno">
            <input type="hidden" name="items_id" :value="item.item_id">
            <input type="hidden" name="item_schedule_id" :value="item.schedule_id">
            <button type="submit" class="btn"
              data-block="true"
              data-size="sm"
              data-color="primary"
              @click="sendEventMovie"
            >プロフィールを入力する</button>
          </form>
        </div>
        <div class="productDetailToast__close"
          @click="closeDetail"
        ><span></span></div>
      </div>
    </div>
    <div class="productDetailToast__backdrop" @click="closeDetail"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
export default {
  name: 'product-detail',
  data() {
    return {
      token: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno
    }
  },
  computed: {
    ...mapState({
      showProductDetail: state => state.uiState.showProductDetail,
      item: state => state.item.selected
    }),
    inputLink() {
      /**
       * text用
       * 引数に渡ったIDを6桁の文字列に変換する
       * @param { Number } id - item_id
       */
      const parseDigit = (id = 0) => {
        const digit = 6
        let str = ''
        for (let i = 0; i < digit - String(id).length; i++) {
          str += '0'
        }
        str += String(id)
        return str
      }
      if (this.item.item_id) {
        return `/contents/${parseDigit(this.item.item_id)}/input${
          window.location.search
          }`
      } else {
        return `/`
      }
    },
    isLoading() {
      return Object.keys(this.item).length === 0
    }
  },
  props: {
    itemsId: String,
    itemScheduleId: String,
    counselorName: String,
    packImage: String,
    type: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.closeDetail()
  },
  methods: {
    // テキスト用：イベント送信
    sendEventText() {
      window.gtag('event', 'InputProfText', {
        cpno: window.Laravel.cpno,
        items_id: this.item.item_id
      })
    },
    // 抽選動画用：イベント送信
    sendEventMovie() {
      window.gtag('event', 'InputProfMovie', {
        cpno: window.Laravel.cpno,
        items_id: this.item.item_id
      })
    },
    closeDetail() {
      this.$store.dispatch(type.RESET_SELECTED_ITEM)
      this.$store.dispatch(type.UPDATE_PRODUCT_DETAIL_VISIBILITY, false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../sass/variables/colors.scss';

.media {
  border-bottom: 1px solid #d8d8d8;
  align-items: center;
  padding: 0 0 16px;
  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title {
    font-weight: bold;
    font-size: 14px;
    &:empty {
      display: block;
      width: 200px;
      height: 14px;
      margin: 5px 0;
      background: #e0e0e0;
      border-radius: 6px;
    }
  }
  .counselorName {
    font-size: 13px;
    opacity: 0.5;
    &:empty {
      display: block;
      width: 140px;
      height: 13px;
      margin: 5px 0;
      background: #e0e0e0;
      border-radius: 6px;
    }
  }
}
.price {
  display: flex;
  justify-content: space-around;
  margin: 16px;
}

.productDetailToast {
  position: fixed;
  opacity: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  &__content {
    border-radius: 6px 6px 0 0;
    z-index: 2;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: calc(100% - 20px);
    padding: 16px;
    background: rgba(255, 255, 255, 0.93);
    -webkit-backdrop-filter: blur(8px);
    transform: translateY(100%);
    transition: transform 250ms ease-in-out;
    will-change: transition;
  }
  &__backdrop {
    z-index: 1;
    cursor: pointer;
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.2);
    transition: opacity 250ms ease-in-out;
    will-change: opacity;
  }

  &__body {
    display: flex;
    padding: 16px 0px;
    > div {
      width: 30%;
      text-align: center;
      &.wbtn {
        width: 100%;
        padding: 0px 30px;
      }
      &.bclo {
        width: 44px;
      }
    }
  }
  &__footer {
    padding-bottom: 16px;
  }

  &__loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  // Modifier visible state
  &[data-visible='true'] {
    opacity: 1;
    z-index: 9999;
    pointer-events: auto;
    .productDetailToast {
      &__backdrop {
        opacity: 1;
      }
      &__content {
        transform: translateY(0);
      }
    }
  }
  &[data-loading='true'] {
    .container {
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ProductDetail.vue